import { call, put, takeEvery } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import {
  ContractorPortalFetchDocuments,
  ContractorPortalFetchDriver,
  ContractorPortalFetchInvoices,
  ContractorPortalFetchPartner,
  SetDriver,
  SetPartner,
} from 'src/constants/actionTypes'
import { ApiService, callContractorPortalSecureApi } from '../api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { Driver } from 'src/interfaces/driver'
import { Partner } from 'src/interfaces/partner'
import { captureSentryError } from 'src/utils/sentry'

function* onFetchPartner(action: AsyncAction<void, Partner>) {
  try {
    const { payload }: { payload: Partner } = yield call(
      callContractorPortalSecureApi,
      Endpoints.FetchPartner,
      {
        method: 'GET',
        apiService: ApiService.Paraworks,
      },
    )

    yield put(ContractorPortalFetchPartner.success(payload))
    yield put(SetPartner.success(payload))

    yield put(ContractorPortalFetchInvoices.request({ partnerId: payload.id }))
    yield put(ContractorPortalFetchDocuments.request({ partnerId: payload.id }))

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.contractorPortal.onFetchPartner] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to fetch partner'

    yield put(ContractorPortalFetchPartner.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

function* onFetchDriver(action: AsyncAction<Driver>) {
  try {
    const { payload }: { payload: Driver } = yield call(
      callContractorPortalSecureApi,
      Endpoints.FetchDriver,
      {
        apiService: ApiService.Paraworks,
      },
    )

    yield put(ContractorPortalFetchDriver.success())
    yield put(SetDriver.request(payload))

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.contractorPortal.onFetchDriver] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to fetch driver'

    yield put(ContractorPortalFetchDriver.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* contractorPortalContractorSaga() {
  yield takeEvery(ContractorPortalFetchDriver.type.REQUEST, onFetchDriver)
  yield takeEvery(ContractorPortalFetchPartner.type.REQUEST, onFetchPartner)
}
